import { render } from "./filter-tag.vue?vue&type=template&id=a0bca64e"
import script from "./filter-tag.vue?vue&type=script&lang=js"
export * from "./filter-tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__